import { createContext, useContext } from 'react'
import noop from 'lib/util/noop'

const ItemContext = createContext({
  isExpanded: true,
  onToggle: noop,
  setIsExpanded: noop,
  ariaId: 'accordion'
})

const useItemContext = () => {
  const context = useContext(ItemContext)

  return context
}

export { useItemContext }
export default ItemContext
